export default "__VITE_ASSET__ufVZbsMF__"